(() => {
  const endpoint = 'https://a.klaviyo.com/client/subscriptions/';
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const defaultRevision = '2026-07-15';

  const dispatch = (form, type, detail) => {
    form.dispatchEvent(new CustomEvent(`nh:klaviyo-subscribe:${type}`, { bubbles: true, detail }));
  };

  const getErrorDetail = (body) => {
    if (!body || !body.errors || !body.errors[0]) return '';
    return body.errors[0].detail || '';
  };

  const subscribe = async ({ email, companyId, listId, revision = defaultRevision }) => {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    const response = await fetch(`${endpoint}?company_id=${encodeURIComponent(companyId)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision
      },
      body: JSON.stringify(payload)
    });
    const body = response.status === 204 ? null : await response.json().catch(() => null);

    return {
      ok: response.ok,
      status: response.status,
      detail: getErrorDetail(body),
      body
    };
  };

  const submit = async (event) => {
    const form = event.target.closest('[data-nh-klaviyo-subscribe]');
    if (!form || form.dataset.nhKlaviyoSubmitting === 'true') return;

    event.preventDefault();

    const emailInput = form.querySelector('input[type="email"]');
    const email = (emailInput?.value || '').trim();
    const companyId = form.dataset.companyId;
    const listId = form.dataset.listId;
    const revision = form.dataset.revision || defaultRevision;

    if (!emailPattern.test(email)) {
      emailInput?.focus();
      dispatch(form, 'error', { type: 'invalid', email });
      return;
    }

    if (!companyId || !listId) {
      dispatch(form, 'error', { type: 'config', email });
      return;
    }

    form.dataset.nhKlaviyoSubmitting = 'true';
    dispatch(form, 'loading', { isLoading: true });

    try {
      const result = await subscribe({ email, companyId, listId, revision });

      if (result.ok) {
        dispatch(form, 'success', { email, status: result.status, body: result.body });
      } else {
        console.error('Klaviyo subscription request failed:', result.status, result.body);
        dispatch(form, 'error', { type: 'request', email, ...result });
      }
    } catch (error) {
      console.error('Klaviyo subscription request failed:', error);
      dispatch(form, 'error', { type: 'connection', email, error });
    } finally {
      form.dataset.nhKlaviyoSubmitting = 'false';
      dispatch(form, 'loading', { isLoading: false });
    }
  };

  window.NhKlaviyoSubscribe = { subscribe };
  document.addEventListener('submit', submit);
})();
